<template>
  <v-container>
    <v-row class="mt-2" v-if="userIsAdmin">
      <v-col align="center">
        <v-card width="1200" :class="getAlarmstatus()">
          <v-card-title class="text--secondary">
            <v-row>
              <v-col cols="12">
                <SAPPortalStatusMatrix
                  :countdown="statusPollCountdown"
                  :portals="adminSAPStatus.portals"
                ></SAPPortalStatusMatrix>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <!--<advent-calendar></advent-calendar>-->
    <v-row class="mt-2">
      <v-col align="center">
        <v-card :loading="loading" :width="userIsAdmin ? 1200 : 900">
          <error-overlay v-model="error" @retry="loadData"></error-overlay>
          <template slot="progress">
            <v-progress-linear
              color="#006c27"
              height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <v-card-title class="text--secondary">
            <div v-if="userIsAdmin">
              All Applications ({{ applications.length }}/{{
                filteredApplications.length
              }})
            </div>
            <div v-if="!userIsAdmin">Your Applications</div>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              label="Search"
              single-line
              color="#006c27"
              hide-details
              style="padding-top: 0; margin-top: 0"
            >
              <template slot="append">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on">mdi-magnify</v-icon>
                  </template>
                  <span
                    >You can wildcard search for name, id or ownerRef, email,
                    firstname, lastname, displayName.</span
                  >
                </v-tooltip>
                <v-tooltip v-if="userIsAdmin" left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      @click="onClickQuickFilter"
                      v-bind="attrs"
                      v-on="on"
                      icon
                      color="#006c27"
                    >
                      <v-icon>{{ getFilterIcon() }}</v-icon>
                    </v-btn>
                  </template>
                  <span
                    >Admin quickfilter! This will filter all applications from
                    API CoE Team</span
                  >
                </v-tooltip>
              </template>
            </v-text-field>
          </v-card-title>
          <v-card-text class="text--primary my-6">
            <v-data-table
              :custom-sort="customSort"
              v-if="!loading"
              must-sort
              :headers="headers"
              :items="filteredApplications"
              :options.sync="tableOptions"
              :hide-default-footer="filteredApplications.length <= 10"
              class="elevation-1"
              @click:row="rowClicked"
            >
              <template slot="no-data">
                You do not have any applications yet! Just create or import one!
              </template>
              <template v-slot:[`item.displayName`]="{ item }">
                <div class="d-flex align-center">
                  <span>{{ item.displayName }}</span>
                  <v-tooltip v-if="!$drupal" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        class="ml-1"
                        v-bind="attrs"
                        v-on="on"
                        :aria-label="'Open ' + item.displayName + ' in new tab'"
                        @click.stop="openApplicationInNewTab(item)"
                      >
                        <v-icon small>mdi-open-in-new</v-icon>
                      </v-btn>
                    </template>
                    <span>Open application in new tab</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:[`item.environment`]="{ item }">
                <v-chip
                  outlined
                  small
                  :color="getEnvironmentColor(item.environment)"
                  dark
                >
                  {{ item.environment }}
                </v-chip>
              </template>
              <template v-slot:[`item.state`]="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      :color="getStatusIconColor(item)"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ getStatusIcon(item) }}
                    </v-icon>
                  </template>
                  <span>{{ getStatusText(item) }}</span>
                </v-tooltip>
              </template>
              <template v-slot:[`item.firstowner`]="{ item }">
                <div class="d-flex align-center">
                  <span>{{ item.firstowner }}</span>
                  <v-chip
                    v-if="isUnresolvedOwner(item.owners && item.owners[0])"
                    x-small
                    label
                    outlined
                    color="red"
                    class="ml-2 unresolved-chip"
                  >
                    Unresolved
                  </v-chip>
                  <v-tooltip
                    v-if="isAmbiguousOwner(item.owners && item.owners[0])"
                    bottom
                    max-width="520"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        x-small
                        label
                        outlined
                        color="#c62828"
                        class="ml-2 unresolved-chip"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon x-small left>mdi-alert-circle-outline</v-icon>
                        {{ ambiguityChipLabel(item.owners && item.owners[0]) }}
                      </v-chip>
                    </template>
                    <div class="owner-ambiguity-tooltip">
                      <div
                        v-for="(line, lineIndex) in ambiguityAlternateLines(item.owners && item.owners[0])"
                        :key="'home-ambiguous-line-' + item.applicationId + '-' + lineIndex"
                        class="owner-ambiguity-line"
                      >
                        {{ line }}
                      </div>
                    </div>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
            <v-row v-if="!loading">
              <v-spacer></v-spacer>
              <v-btn
                @click="createApplication"
                color="#006c27"
                dark
                class="mr-3 mt-9 mb-5"
              >
                CREATE
              </v-btn>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <application-create-overlay v-model="createOverlay">
    </application-create-overlay>
    <announcement-dialog
      v-model="announcementDialog"
      :announcement="announcement"
      @confirm="confirmAnnouncement"
    ></announcement-dialog>
  </v-container>
</template>

<script>
import cass from "../api/cass";
import ErrorOverlay from "../components/ErrorOverlay.vue";
import ApplicationCreateOverlay from "../components/ApplicationCreateOverlay.vue";
import AnnouncementDialog from "../components/AnnouncementDialog.vue";
import SAPPortalStatusMatrix from "../components/SAPPortalStatusMatrix.vue";
import announce from "../api/announce.js";
import { isOwnerAmbiguous, formatAmbiguityAlternateLine } from "../utils/ownerProjectionAmbiguity";
import {
  applicationListQuery,
  applicationListQueryMatchesState,
  applicationListStateFromQuery,
} from "../utils/applicationListRouteState";
import {
  hasCompletePortalStatus,
  unavailablePortalStatuses,
} from "../utils/sapapiDiagnostics";

export default {
  name: "home",

  components: {
    ErrorOverlay,
    ApplicationCreateOverlay,
    AnnouncementDialog,
    SAPPortalStatusMatrix,
  },

  async mounted() {
    this.loadData();
  },
  beforeDestroy() {
    console.log("beforeDestroy");
    this.$emitter.off("sap_status_polled", this.onSAPStatusPolled);
    if (this.lastUpdateInterval != null) {
      clearInterval(this.lastUpdateInterval);
      this.lastUpdateInterval = null;
    }
  },
  data() {
    const listState = this.$drupal
      ? applicationListStateFromQuery({})
      : applicationListStateFromQuery(this.$route.query);

    return {
      search: listState.search,
      tableOptions: {
        page: listState.page,
        itemsPerPage: 10,
        sortBy: [listState.sortBy],
        sortDesc: [listState.sortDesc],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true,
      },
      applications: [],
      filteredApplications: [],
      error: null,
      loading: true,
      createOverlay: false,
      adminQuickFilter: false,
      statusPollCountdown: "waiting for status...",
      lastUpdateInterval: null,
      userIsAdmin: false,
      announcementDialog: false,
      announcement: {},
      adminSAPStatus: { portals: [], override: null },
      headers: [
        {
          text: "Name",
          align: "start",
          value: "displayName",
          width: "46%",
        },
        {
          text: "Permission Model",
          value: "permissionModel",
          filterable: false,
        },

        { text: "Environment", value: "environment", filterable: false },
        { text: "Status", value: "state", filterable: false, sortable: false },
      ],
    };
  },
  created() {
    console.log("HOME CREATE");
    this.$emitter.on("sap_status_polled", this.onSAPStatusPolled);
    this.$emitter.on("home_reload", () => {
      console.log("home_reload");
      this.loadData();
    });
  },
  watch: {
    search() {
      this.applyFilter();
      if (!this.$drupal && this.tableOptions.page !== 1) {
        this.tableOptions = { ...this.tableOptions, page: 1 };
      }
      this.syncListRouteState();
    },
    tableOptions: {
      deep: true,
      handler() {
        this.syncListRouteState();
      },
    },
    "$route.query"() {
      this.restoreListStateFromRoute();
    },
  },
  methods: {
    currentListState() {
      return {
        search: this.search,
        page: this.tableOptions.page,
        sortBy: this.tableOptions.sortBy[0] || "displayName",
        sortDesc: this.tableOptions.sortDesc[0] === true,
      };
    },
    restoreListStateFromRoute() {
      if (this.$drupal) {
        return;
      }

      const listState = applicationListStateFromQuery(this.$route.query);
      this.search = listState.search;
      this.tableOptions = {
        ...this.tableOptions,
        page: listState.page,
        sortBy: [listState.sortBy],
        sortDesc: [listState.sortDesc],
      };
      this.applyFilter();
    },
    syncListRouteState() {
      if (this.$drupal) {
        return;
      }

      const listState = this.currentListState();
      if (applicationListQueryMatchesState(this.$route.query, listState)) {
        return;
      }

      this.$router.replace({
        name: "Home",
        query: applicationListQuery(this.$route.query, listState),
      });
    },
    confirmAnnouncement(annoncement) {
      console.log("Confirm Announcement: ", annoncement);
      announce
        .confirmAnnoncement(annoncement.uuid)
        .then((response) => {
          console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getStatus(env) {
      if (this.$sap != undefined && this.$sap.status != null) {
        var result = this.$sap.status.filter((element) => {
          return element.environment === env;
        });
        if (result == undefined || result == null || result.length == 0) {
          return { status: "ERROR" };
        }
        return result[0];
      } else {
        return { status: "Loading ..." };
      }
    },
    onSAPStatusPolled() {
      this.loadAdminSAPStatus();
    },
    loadAdminSAPStatus() {
      if (!this.$userData.cass.isUserAdmin) return;
      cass
        .getAdminSAPAPIStatus()
        .then((response) => {
          if (!hasCompletePortalStatus(response.data)) {
            throw new Error("CASS returned an incomplete portal status response.");
          }
          this.adminSAPStatus = response.data;
        })
        .catch((error) => {
          console.error("Could not load detailed SAPAPI status", error);
          this.adminSAPStatus = {
            portals: unavailablePortalStatuses(
              "Portal status is unavailable while CASS admin status cannot be reached."
            ),
            override: null,
          };
        });
    },
    getAlarmstatus() {
      var rc = "";
      if (this.$sap != null && this.$sap.status != null) {
        this.$sap.status.forEach((element) => {
          if (element.status != "ONLINE") {
            rc = "alarmstatus";
          }
        });
        if (
          this.$sap.timestamp + (process.env.VUE_APP_STATUS_CHECK + 5) * 1000 <
          Date.now()
        ) {
          rc = "alarmstatus";
        }
      }
      return rc;
    },
    addAdminContext() {
      if (this.$userData.cass.isUserAdmin) {
        this.userIsAdmin = true;
        const hasOwnerHeader =
          this.headers.findIndex((header) => header.value === "firstowner") !== -1;
        if (!hasOwnerHeader) {
          this.headers.splice(1, 0, {
            text: "Owner",
            value: "firstowner",
            filterable: false,
            cellClass: "ownerClass",
          });
        }
        this.headers[0].width = "35%";
        if (this.lastUpdateInterval == null) {
          this.updateStatusPollCountdown();
          this.lastUpdateInterval = setInterval(() => {
            this.updateStatusPollCountdown();
          }, 1000);
        }
      }
    },
    updateStatusPollCountdown() {
      const timestamp = this.$sap && this.$sap.timestamp;
      const pollInterval = Number(process.env.VUE_APP_STATUS_CHECK);
      if (!timestamp || Number.isNaN(new Date(timestamp).getTime()) || pollInterval <= 0) {
        this.statusPollCountdown = "waiting for status...";
        return;
      }
      const remainingMillis = Math.max(0, new Date(timestamp).getTime() + pollInterval - Date.now());
      this.statusPollCountdown = `refresh in ${Math.ceil(remainingMillis / 1000)}s`;
    },
    getFilterIcon() {
      if (this.adminQuickFilter) {
        return "mdi-account-filter";
      }
      return "mdi-account-filter-outline";
    },
    onClickQuickFilter() {
      this.adminQuickFilter = !this.adminQuickFilter;
      this.applyFilter();
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (typeof a[index] !== "undefined") {
          if (!isDesc[0]) {
            return a[index]
              .toLowerCase()
              .localeCompare(b[index].toLowerCase(), undefined, {
                numeric: true,
                sensitivity: "base",
              });
          } else {
            return b[index]
              .toLowerCase()
              .localeCompare(a[index].toLowerCase(), undefined, {
                numeric: true,
                sensitivity: "base",
              });
          }
        }
      });
      return items;
    },
    loadData() {
      // load announcements
      announce
        .getAnnouncements()
        .then((response) => {
          console.log(response);
          if (response.data.length > 0) {
            this.announcement = response.data[0];
            this.announcementDialog = true;
          } else {
            console.log("no announcements for user");
          }
        })
        .catch((error) => {
          console.log(error);
        });

      this.addAdminContext();
      this.loadAdminSAPStatus();
      this.error = null;
      this.loading = true;
      cass
        .getApplications()
        .then((response) => {
          console.log(response);
          this.applications = response.data;
          this.applications.forEach((app) => {
            app.firstowner = this.getOwnerLabel(app.owners[0]);
          });

          this.applyFilter();
        })
        .catch((error) => {
          console.log("OH NO");
          this.applications = [];
          this.error = cass.handleError(error);
        })
        .finally(() => (this.loading = false));
    },
    getEnvironmentColor(env) {
      if (env === "PRODUCTION") {
        return "#006c27";
      }
      if (env == "QUALITY") {
        return "#fccf46";
      }
      if (env == "DEVELOPMENT") {
        return "#1d9bb2";
      }
    },
    getStatusIcon(item) {
      if (item.state == "READY_TO_USE") {
        return "mdi-shield-check-outline";
      }
      return "mdi-shield-alert-outline";
    },
    getStatusIconColor(item) {
      if (item.state == "READY_TO_USE") {
        return "#006c27";
      }
      return "red";
    },
    getStatusText(item) {
      if (item.state == "NO_VALID_SECRET") {
        return "Your Application does not have a valid secret";
      } else if (item.state == "MISSING_REDIRECTURI") {
        return "Your Application does not have a valid RedirectURI";
      }
      return "All Good! 🎉";
    },
    getOwnerLabel(owner) {
      if (!owner) {
        return "";
      }
      if (owner.isUnresolved === true) {
        return owner.ownerRef || owner.email || "";
      }
      if (owner.ownerType === "internal") {
        if (owner.displayName && owner.displayName.trim() !== "") {
          return owner.displayName;
        }
        if (owner.ownerRef) {
          return owner.ownerRef;
        }
        return owner.email || "";
      }
      if (owner.ownerType === "external") {
        if (owner.ownerRef && owner.ownerRef.trim() !== "") {
          return owner.ownerRef;
        }
        return owner.email || "";
      }
      if (owner.ownerRef) {
        return owner.ownerRef;
      }
      if (owner.email) {
        return owner.email;
      }
      if (owner.ext14) {
        return owner.ext14;
      }
      return "";
    },
    isUnresolvedOwner(owner) {
      return !!(owner && owner.isUnresolved === true);
    },
    isAmbiguousOwner(owner) {
      return isOwnerAmbiguous(owner);
    },
    ambiguityChipLabel(owner) {
      const count = Number.isInteger(owner && owner.candidateCount) ? owner.candidateCount : 2;
      return "Ambiguous (" + count + ")";
    },
    ambiguityAlternateLines(owner) {
      if (!this.isAmbiguousOwner(owner)) {
        return [];
      }
      const alternates = Array.isArray(owner && owner.candidates) ? owner.candidates : [];
      return alternates.map((alternate) => formatAmbiguityAlternateLine(alternate));
    },
    getOwnerSearchText(owner) {
      if (!owner) {
        return "";
      }
      const searchParts = [
        owner.ownerRef,
        owner.email,
        owner.firstname,
        owner.lastname,
        owner.displayName,
      ];
      return searchParts
        .filter((value) => typeof value === "string" && value.trim() !== "")
        .join(" ")
        .toUpperCase();
    },
    applyFilter() {
      //console.log("apply Filter");
      this.filteredApplications = [];
      this.applications.forEach((app) => {
        var search = this.search.toUpperCase();

        var found1 = app.displayName.toUpperCase().indexOf(search) != -1;
        var found2 = app.applicationId.toUpperCase().indexOf(search) != -1;
        var found3 =
          app.apiMgmtApplicationId.toUpperCase().indexOf(search) != -1;
        var found4 = false;
        for (var j = 0; j < app.owners.length; j++) {
          if (this.getOwnerSearchText(app.owners[j]).indexOf(search) != -1) {
            found4 = true;
            break;
          }
        }
        if (this.adminQuickFilter) {
          for (j = 0; j < app.owners.length; j++) {
            const ownerSearchText = this.getOwnerSearchText(app.owners[j]);
            if (
              ownerSearchText.indexOf("POLTOKZY") != -1 ||
              ownerSearchText.indexOf("MAZURTMA") != -1 ||
              ownerSearchText.indexOf("KOHNSMRK") != -1 ||
              ownerSearchText.indexOf("ADELHCRI") != -1
            ) {
              return;
            }
          }
        }
        if (found1 || found2 || found3 || found4) {
          this.filteredApplications.push(app);
        }
      });
    },
    rowClicked(item) {
      this.$router
        .push({
          name: "Application",
          params: { applicationid: item.applicationId },
          query: this.$drupal ? {} : { returnedFromList: "true" },
        })
        .catch(() => {
          console.log("Something bad happend .. start over");
          window.location.reload();
        });
    },
    openApplicationInNewTab(item) {
      const target = this.$router.resolve({
        name: "Application",
        params: { applicationid: item.applicationId },
      });
      const applicationWindow = window.open(
        target.href,
        "_blank",
        "noopener,noreferrer"
      );

      if (applicationWindow) {
        applicationWindow.opener = null;
      }
    },
    createApplication() {
      this.createOverlay = true;
    },
  },
};
</script>

<style>
.ownerClass {
  min-width: 220px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.unresolved-chip {
  font-weight: 600;
}

.owner-ambiguity-tooltip {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.owner-ambiguity-line {
  font-size: 0.78rem;
  line-height: 1.1rem;
}

.alarmstatus {
  animation: pulsate 1s ease-out infinite;
}

@-webkit-keyframes pulsate {
  0% {
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
      0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  }
  50% {
    box-shadow: 0 0 24px 2px red;
  }
  100% {
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%),
      0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
  }
}
</style>
<style type="sass" scoped>
::v-deep
  .theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(
    .v-data-table__empty-wrapper
  ) {
  background: #ebeef0 !important;
}
</style>
